import { ProjectTemplateDefinitionService } from './project-template-definition.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ProjectTemplateDefinitionResolverEnteredAction,
  ProjectTemplateDefinitionLoadedAction,
  LoadProjectTemplateDefinitionErroredAction,
} from './project-template-definition.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class ProjectTemplateDefinitionEffects {
  loadTemplateDefinition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectTemplateDefinitionResolverEnteredAction),
      switchMap((action) =>
        this.projectTemplateDefinitionService.loadTemplateDefinition(action.templateId).pipe(
          map((definition) => ProjectTemplateDefinitionLoadedAction({ definition })),
          catchError((error) =>
            of(LoadProjectTemplateDefinitionErroredAction({ statusCode: error.status })),
          ),
        ),
      ),
    ),
  );

  constructor(
    protected actions$: Actions,
    protected projectTemplateDefinitionService: ProjectTemplateDefinitionService,
  ) {}
}
